import { paymentsAxios } from 'services/controllers/payments';

import * as t from './types';

export const SubscriptionsApi = {
  getSubscriptionDetails: async () => {
    const { data } = await paymentsAxios.get<t.IUserSubscriptionDetailsResponse>('/subscription-details');
    return data;
  },

  subscriptionCheckout: async (requestBody: t.ISubscriptionCheckoutBody) => {
    const { data } = await paymentsAxios.post<t.ISubscriptionCheckoutResponse>('/checkout', requestBody);
    return data;
  },

  cancelSubscription: async () => {
    const { data } = await paymentsAxios.delete<t.ICancelSubscriptionResponse>(`/cancel-subscription`);
    return data;
  },
};
